module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "C593"
  }, [_c('span', {
    staticClass: "size_145"
  }, [_c('span', {
    staticClass: "color_0B0E11"
  }, [_c('strong', [_c('span', {
    attrs: {
      "id": "id_5"
    }
  }, [_vm._v("Line")]), _vm._v(" and Shape")])])])]), _vm._v(" "), _c('p', {
    staticClass: "C580"
  }, [_vm._v("Lines connect elements; they lead the eye and create movement, patterns, and relationships. Use line in repetition to lead the eye where you want it to go, to tell a story, or to create an emotional response. The angles of diagonal lines create movement and depth—they are very active and dynamic. Soft, gentle curves are comfortable and relaxing, even sensual; horizontal lines are restful, while vertical lines are lofty and grand. In combination, vertical and horizontal lines are solid and reliable.")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "C580"
  }, [_c('em', [_vm._v("Intersections")]), _vm._v(" uses a combination of diagonal lines and circular motifs to create a dynamic and active story.")]), _vm._v(" "), _c('p', {
    staticClass: "C572"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "img/15_3.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab064674","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/12___Line_a.vue
// module id = 87
// module chunks = 0